/* Loads Swiper only on pages that actually build a carousel.
 *
 * Swiper is constructed in exactly two places in this theme:
 * theme.Nov_Swipercarousel (js-theme.js), which the section registry calls for
 * every [data-section-type="nov-swiper"], and nov.initNovProductTabsSlider
 * (js-nuranium.js), which nov-collection-tabs / nov-ajax_collection_tab use.
 * Nothing else — no section, snippet or inline script — touches window.Swiper.
 * Both of those entry points are wrapped, at the bottom of their own files, to
 * go through window.jmLoadSwiper first, so the library can be fetched on demand
 * without any call site having to know about it.
 *
 * Measured on the storefront: the homepage builds one Swiper (the categories
 * strip in nov-collection-summary); collection and product pages build none, and
 * were paying 27.6 KB over the wire and ~96 KB of parse for a library they never
 * instantiated. nov-collection-tabs and nov-testimonials-thumb appear only in
 * the unused index.preset-b / index.preset-c templates.
 *
 * This file is deferred, so it runs with the document fully parsed: the check
 * below sees every carousel the page rendered, and the fetch starts alongside
 * the theme's other deferred scripts rather than after them.
 */
(function () {
  'use strict';

  var SELECTOR = '.nov-swiper-carousel, [data-section-type="nov-swiper"]';
  var IDLE = 0, LOADING = 1, DONE = 2;
  var state = IDLE;
  var waiting = [];

  function ready() {
    state = DONE;
    /* The Hebrew screen-reader strings are applied by wrapping the constructor,
       so that has to happen before the first carousel is built. */
    if (window.jmA11y && typeof window.jmA11y.wrapSwiper === 'function') {
      window.jmA11y.wrapSwiper();
    }
    var pending = waiting;
    waiting = [];
    for (var i = 0; i < pending.length; i++) {
      try {
        pending[i]();
      } catch (error) {
        setTimeout(function () { throw error; });
      }
    }
  }

  function loadSwiper(callback) {
    if (typeof window.Swiper === 'function' && state !== LOADING) {
      state = DONE;
      if (typeof callback === 'function') callback();
      return;
    }
    if (typeof callback === 'function') waiting.push(callback);
    if (state !== IDLE) return;

    var url = window.jmLibs && window.jmLibs.swiper;
    if (!url) { state = DONE; waiting.length = 0; return; }

    state = LOADING;
    var script = document.createElement('script');
    script.src = url;
    script.onload = ready;
    script.onerror = function () { state = DONE; waiting.length = 0; };
    document.head.appendChild(script);
  }

  window.jmLoadSwiper = loadSwiper;

  if (typeof window.Swiper === 'function') {
    state = DONE;
  } else if (document.querySelector(SELECTOR)) {
    loadSwiper();
  }
})();
